<template>
  <button :class="buttonClasses" type="button">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "PURPLE",
    },
  },
  computed: {
    buttonClasses() {
      let colorClass = "";
      switch (this.color) {
        case "GRAY":
          colorClass = "btn-gray";
          break;
        case "PURPLE":
          colorClass = "btn-purple";
          break;
        case "RED":
          colorClass = "btn-red";
          break;
        case "SPECIAL":
          colorClass = "btn-special";
          break;
        case "WHITE":
          colorClass = "btn-white";
          break;
        case "DARKPURPLE":
          colorClass = "btn-darkpurple";
          break;
        case "LIGHTPURPLE":
          colorClass = "btn-lightpurple";
          break;
        case "LIGHTBLUE":
          colorClass = "btn-lightblue";
          break;
        case "DARKGREEN":
          colorClass = "btn-darkgreen";
          break;
        case "LIGHTYELLOW":
          colorClass = "btn-lightyellow";
          break;
        default:
          colorClass = "btn-purple";
      }
      return ["btn", colorClass, "custom-button"];
    },
  },
};
</script>

<style>
/* 自定义按钮样式 */
.custom-button {
  border-radius: 10px;
  padding: 0.2rem 1.5rem;
}

/* 自定义颜色类 */
.btn-gray {
  background-color: #bababa !important;
  color: #fff !important;
}

.btn-purple {
  background-color: #702dff !important;
  color: #fff !important;
}

.btn-red {
  background-color: #f13e3e !important;
  color: #fff !important;
}

.btn-special {
  background-color: #702dff !important;
  color: #ffffff !important;
}

.btn-special:hover,
.btn-special:focus,
.btn-special:active {
  background-color: #6523f2 !important;
  color: #fff !important;
}

.btn-white {
  background-color: #ffffff !important;
  color: #000000 !important;
}
.btn-darkpurple {
  background-color: #ae76ff !important;
  color: #fff !important;
}

.btn-lightpurple {
  background-color: #dacdf7 !important;
  color: #000 !important;
}

.btn-lightblue {
  background-color: #d6e0f5 !important;
  color: #000 !important;
}

.btn-darkgreen {
  background-color: #91c13a !important;
  color: #fff !important;
}

.btn-lightyellow {
  background-color: #f1c044 !important;
  color: #000 !important;
}
</style>
